import { DeclinedMessageCard } from '../../../../../Components/Cards/VenueCards/VenueCards'
import { DeclinedMessageCardFragment } from '../../../../../Components/Cards/VenueCards/VenueCards.generated'
import VenueCardContainer from '../../../../../Components/Material/Card/CardContainer'
import { CardListItem } from '../../../../../Components/Material/Card/CardStyles'
import EmptyState from '../../../../../Components/Material/Card/EmptyState'

interface DeclinedVenuesProps {
  declines: Array<DeclinedMessageCardFragment | null>
  compact: boolean
}
const DeclinedVenues = ({
  declines,
  compact,
}: DeclinedVenuesProps): JSX.Element => {
  const messageCards = declines
    .sort((a, b) => {
      if (!a?.message?.declinedAt) {
        return 1
      }
      if (!b?.message?.declinedAt) {
        return -1
      }
      return a.message.declinedAt.localeCompare(b.message.declinedAt)
    })
    .map((interest) => {
      if (!interest) {
        throw new Error('Message was null')
      }
      return (
        <CardListItem key={interest.id} size='small'>
          <DeclinedMessageCard interest={interest} size='small' />
        </CardListItem>
      )
    })
  return (
    <VenueCardContainer
      compact={compact}
      title="Venues you didn't like 👎"
      subtitle='You told us these venues aren’t a good match for your enquiry, which frees up space for more venues to message you.'
      emptyState={
        <EmptyState contentType='declines'>
          Mark venues as not a good match and they will appear here. This frees
          up space for more venues to message you.
        </EmptyState>
      }
    >
      {messageCards}
    </VenueCardContainer>
  )
}

export default DeclinedVenues
